module.exports = __webpack_public_path__ + "static/media/gobierno_color_transparente_white.719ab5fc.png";